import { useEffect, useState } from 'react';
import SeoService from './SeoService';

export default function useSeo(path) {
    const [seo, setSeo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        setLoading(true);

        SeoService
            .get(path)
            .then(data => {
                if (!mounted) {
                    return;
                }

                if (data?.error) {
                    setSeo(null);
                    return;
                }

                setSeo(data);
            })
            .catch(() => {
                if (mounted) {
                    setSeo(null);
                }
            })
            .finally(() => {
                if (mounted) {
                    setLoading(false);
                }
            });

        return () => {
            mounted = false;
        };
    }, [path]);

    return {
        seo,
        loading
    };
}